import { schema } from 'normalizr';

const entrantSchema = new schema.Entity('entrants', {});

export default entrantSchema;
